import apiClient from "./apiClient";
import {
  GetUserProfileRequest,
  GetUserProfileResponse,
  SetUserProfileRequest,
  SetUserProfileResponse,
  LangElem,
} from "./Models/UserProfileModel";
import { AxiosResponse } from "axios";

export const getUserProfile = async (
  securityToken: string,
  language: string,
  userName: string,
  hasSecurityToken: boolean
): Promise<GetUserProfileResponse> => {
  const requestData: GetUserProfileRequest = {
    SecurityToken: securityToken,
    Language: language,
    UserName: userName,
    HasSecurityToken: hasSecurityToken,
  };

  try {
    const response: AxiosResponse<GetUserProfileResponse> = await apiClient({
      method: "post",
      url: "/UserProfile/GetUserProfileData",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("getUserProfile Error:", error);
    throw error;
  }
};

export const saveUserProfile = async (
  securityToken: string,
  language: string,
  name: string,
  lastName: string,
  eMail: string
): Promise<SetUserProfileResponse> => {
  const requestData: SetUserProfileRequest = {
    SecurityToken: securityToken,
    Language: language,
    Name: name,
    LastName: lastName,
    EMail: eMail,
  };

  try {
    const response: AxiosResponse<SetUserProfileResponse> = await apiClient({
      method: "post",
      url: "/UserProfile/SetUserProfileData",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("setUserProfile Error:", error);
    throw error;
  }
};
